import apiClient from "./api.client.service";

export interface CreateBlueprintPayload {
  jobId: string;
  roundId: string;
  jdText: string;
  roleTitle?: string;
  experienceLevel?: string;
}

export interface SimulationBlueprint {
  _id: string;
  blueprintVersion: string;
  archetypeName: string;
  overlayId: string;
  jobId: string;
  roundId: string;
  orgId: string;
  lockedAt?: string;
  createdAt: string;
  updatedAt: string;
}

class SimulationService {
  private APIBaseUrl: string;
  static instance: SimulationService;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  static getInstance(): SimulationService {
    if (!SimulationService.instance) {
      SimulationService.instance = new SimulationService();
    }
    return SimulationService.instance;
  }

  async createBlueprint(
    payload: CreateBlueprintPayload,
  ): Promise<SimulationBlueprint | null> {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/simulation/blueprints`,
        payload,
      );
      return response.data;
    } catch (error: any) {
      console.error("SimulationService ~ createBlueprint ~ error:", error);
      // Don't throw — blueprint creation is best-effort during publish
      return null;
    }
  }

  async getBlueprintByRound(
    roundId: string,
  ): Promise<SimulationBlueprint | null> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/simulation/blueprints/by-round/${roundId}`,
      );
      return response.data;
    } catch (error: any) {
      // 404 is expected when no blueprint exists yet
      if (error?.response?.status === 404) {
        return null;
      }
      console.error(
        "SimulationService ~ getBlueprintByRound ~ error:",
        error,
      );
      return null;
    }
  }
}

const simulationService = SimulationService.getInstance();
export default simulationService;
